import React from 'react';

interface Props {
  className?: string;
  title?: string;
  actions?: React.ReactNode;
  list: Array<{
    key: string;
    name: React.ReactNode;
    value: React.ReactNode;
    hide?: boolean;
  }>;
}

export function DefinitionList({ className, title, actions, list }: Props) {
  return (
    <div className={className}>
      <header className="flex justify-between">
        {title !== undefined && (
          <h2 className="text-base font-semibold">{title}</h2>
        )}
        {actions && <div>{actions}</div>}
      </header>
      <dl className="mt-2 grid grid-cols-[min-content_1fr] overflow-hidden">
        {list
          .filter(({ hide }) => !hide)
          .map(({ key, name, value }) => (
            <React.Fragment key={key}>
              <dt className="flex items-center text-nowrap border-b border-silver py-1.5 pr-8 text-xs font-semibold uppercase">
                {name}
              </dt>
              <dd className="flex min-w-0 items-center gap-2 border-b border-silver py-1.5">
                {value}
              </dd>
            </React.Fragment>
          ))}
      </dl>
    </div>
  );
}
